import React, { FC, useEffect } from "react";
import classNames from "classnames";
import { List } from "antd-mobile";
import styles from "./styles.module.less";
import { createPortal } from "react-dom";

export interface MobileTopDownMenuItem {
  key: string;
  label: React.ReactNode;
  onClick: () => void;
}
export interface MobileTopDownMenuProps {
  visible: boolean;
  onClose: () => void;
  menusList: MobileTopDownMenuItem[][];
}

export const MobileTopDownMenu: FC<MobileTopDownMenuProps> = ({
  visible,
  children,
  onClose,
  menusList,
}) => {
  const onMaskClick = () => {
    onClose();
  };

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    } else {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    }
  }, [visible]);

  return (
    <div
      className={classNames(styles.mobileTopDownMenu, {
        [styles.visible]: visible,
      })}
    >
      {/* {children} */}

      {menusList.map((menus, index) => {
        return (
          <List key={index}>
            {menus.map((item) => {
              return (
                <List.Item
                  onClick={() => {
                    item.onClick();
                  }}
                  key={item.key}
                >
                  {item.label}
                </List.Item>
              );
            })}
          </List>
        );
      })}

      {visible &&
        createPortal(
          <div
            className={styles.mobileTopDownMenuMask}
            onClick={onMaskClick}
          />,
          document.body
        )}
    </div>
  );
};
